import { createQuery } from 'react-query-kit';

import { PostGreSQLInterval, privateApi } from 'api';

export type GetFormsParams = object;

export type Form = {
  id: string;
  name: string;
  duration_valid?: PostGreSQLInterval;
};

export type GetFormsResult = Form[];

async function getForms(_params: GetFormsParams) {
  // make api call
  const result = await privateApi.get<GetFormsResult>(`${import.meta.env.VITE_API_BASE_URL}/forms`, {});

  return result.data;
}

const useGetForms = createQuery<GetFormsResult, GetFormsParams, Error>({
  queryKey: ['tenant_forms'],
  fetcher: (variables) => getForms(variables),
});

export { useGetForms };
